import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import isInteger from '../utility/isInteger'

// Redux type and action creators
const { Types, Creators } = createActions({
  timeSliderInitialized: ['marks', 'minValue', 'maxValue'],
  timeSliderValueUpdated: ['value'],
  timeSliderValueDecremented: [],
  timeSliderValueIncremented: [],
  timeSliderMarksUpdated: ['marks', 'value'],
  timeSliderSeasonUpdated: ['marks', 'value'],
  timeSliderReset: [],
  reset: []
})

export const TimeSliderTypes = Types
export default Creators

// Initial state
export const INITIAL_STATE = Immutable({
  marks: {},
  minValue: null,
  maxValue: null,
  value: null
})

// Redux reducers
export const timeSliderInitialized = (
  state,
  { marks, minValue, maxValue, value }
) => {
  const { value: prevValue } = state

  const nextValue = prevValue || value || maxValue
  return state.merge({ marks, minValue, maxValue, value: nextValue })
}

export const timeSliderMarksUpdated = (state, { marks, value }) => {
  if (!value) {
    return state
  }

  const epochtimes = Object.keys(marks).sort()
  if (epochtimes.includes(value.toString())) {
    return state
  } else if (epochtimes.length === 0) {
    return state
  } else {
    return state.merge({
      value: parseInt(epochtimes[epochtimes.length - 1], 10)
    })
  }
  // const nextValue = prevValue || value || maxValue
  // return state.merge({ marks, minValue, maxValue, value: nextValue })
}

export const timeSliderValueUpdated = (state, { value }) => {
  if (isInteger(value)) {
    return state.merge({ value })
  } else {
    const epochTime = new Date(value).getTime()
    return state.merge({ value: epochTime })
  }
}

export const timeSliderValueIncremented = state => {
  const { value, marks } = state
  const timestamps = Object.keys(marks).sort()
  const index = timestamps.indexOf(value.toString())

  if (index === -1 || index >= timestamps.length - 1) {
    return state
  }
  const nextValue = parseInt(timestamps[index + 1], 10)
  return state.merge({ value: nextValue })
}

export const timeSliderValueDecremented = state => {
  const { value, marks } = state
  const timestamps = Object.keys(marks).sort()
  const index = timestamps.indexOf(value.toString())

  if (index === -1 || index <= 0) {
    return state
  }
  const nextValue = parseInt(timestamps[index - 1], 10)
  return state.merge({ value: nextValue })
}

export const timeSliderReset = state => {
  return INITIAL_STATE
}

// Assign types to reducers
export const reducer = createReducer(INITIAL_STATE, {
  [Types.TIME_SLIDER_INITIALIZED]: timeSliderInitialized,
  [Types.TIME_SLIDER_VALUE_UPDATED]: timeSliderValueUpdated,
  [Types.TIME_SLIDER_VALUE_INCREMENTED]: timeSliderValueIncremented,
  [Types.TIME_SLIDER_VALUE_DECREMENTED]: timeSliderValueDecremented,
  [Types.TIME_SLIDER_MARKS_UPDATED]: timeSliderMarksUpdated,
  [Types.TIME_SLIDER_SEASON_UPDATED]: timeSliderMarksUpdated,
  [Types.TIME_SLIDER_RESET]: timeSliderReset,
  [Types.RESET]: timeSliderReset
})



// WEBPACK FOOTER //
// ./src/redux/timeSliderRedux.js